import { useContext } from 'react';
import { createContext } from 'react';

import { ModalLayoutProps } from '../@types/ModalLayoutProps';

export const ModalLayoutContext = createContext<ModalLayoutProps>({} as ModalLayoutProps);

ModalLayoutContext.displayName = 'ModalLayout';

const ModalLayoutProvider = (props: ModalLayoutProps) => (
	<ModalLayoutContext.Provider value={props}>{props.children}</ModalLayoutContext.Provider>
);

export const useModalLayout = () => {
	const context = useContext(ModalLayoutContext);

	return context;
};

export default ModalLayoutProvider;
